<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div class="row">
      <div class="col-3">
        <div class="label">วันที่</div>
        <date-picker v-model="dateRange" type="daterange"></date-picker>
      </div>
      <div class="col-3">
        <div class="label">โครงการ</div>
        <project-select v-model="query.project"
        :selectedProjectId="setProject"
        @defaultProject="handleChange"></project-select>
      </div>
      <div class="col-3">
        <div class="label">บ้านเลขที่</div>
        <el-input v-model="query.home_no" />
      </div>
      <div class="col-3">
        <div class="label">ชื่อลูกค้า</div>
        <el-input v-model="query.name" />
      </div>
    </div>
    <div class="search">
      <div class="text-right mt-2 pr-2">
        <sc-button variant="warning" @click="handleClickClear">clear</sc-button>
      </div>
      <div class="mt-2">
        <sc-button variant="primary" @click="handleClickSearch">ค้นหา</sc-button>
      </div>
    </div>

    <div>
      <div class="text-center" v-if="!total">ไม่มีข้อมูล</div>
      <div>
        <div class="test-left" style="float: left">
          <p class="mb-1 mt-2">{{ totalCount }}</p>
        </div>
        <div class="text-right" style="float: right">
            <button variant="secondary" @click.prevent="handleClickDownloadAsCSV">
              Download
            </button>
          </div>
        <div style="clear: both"></div>
        <div class="session-row header">
          <div class="cell">Feature</div>
          <div class="cell">Score</div>
          <div class="cell">บ้านเลขที่</div>
          <div class="cell">โครงการ</div>
          <div class="cell">ชื่อลูกค้า</div>
          <div class="cell">Comment</div>
          <div class="cell">วันที่</div>
        </div>
        <div class="mb-4">
          <div class="session-row" v-for="feedback in feedbackList" :key="feedback.id">
            <div class="cell">{{ feedback.feedback_feature_id }}</div>
            <div class="cell">{{ feedback.score }}</div>
            <div class="cell">{{ feedback.home.address_no }}</div>
            <div class="cell">{{ feedback.project.project_code }}</div>
            <div class="cell">{{ `${feedback.user.user_profile.first_name} ${feedback.user.user_profile.last_name}` }}</div>
            <div class="cell">{{ feedback.comment || '-' }}</div>
            <div class="cell">{{ feedback.created_at }}</div>
          </div>
        </div>
        <div class="text-right">
          <el-pagination background layout="prev, pager, next" :total="total" :size="10" :current-page="+query.page"
            @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import axios from "axios";
import PageWrapper from "../../../lib/components/PageWrapper";
import { convertDateTimeToTimeText } from "@/lib/dateTime";
import { baanRueJaiClient } from "@/dependencies";
import { Row, Col } from "element-ui";
import { DateTime } from "luxon";
import ProjectSelect from "@/lib/components/ProjectSelect";
import { Input, Pagination, Select, Option } from "element-ui";
import DatePicker from "@/lib/components/DatePicker";
import ScButton from "@/lib/components/ScButton";

export default {
  name: "FeedbackReportPage",
  components: {
    PageWrapper,
    ProjectSelect,
    DatePicker,
    ScButton,
    "el-row": Row,
    "el-col": Col,
    "el-input": Input,
    "el-pagination": Pagination,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const pageWrapper = {
      title: "You tell us Report",
      hasPad: true,
    };
    const query = {
      name: null,
      home_no: null,
      project_id: null,
      from: null,
      to: null,
      page: 1,
    };

    return {
      pageWrapper,
      feedbackList: [],
      total: 1,
      query,
      dateRange: [],
    };
  },
  computed: {
    setProject() {
      return this.$route.query.project_id
    },
    queryParams() {
      const { home_no, name, from, to, page, project_id } =
        this.$route.query;

      return {
        from,
        to,
        project_id,
        home_no,
        name,
        page,
      };
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.feedbackList.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = +this.query.page || 1;
      const end = isLastPage ? total : currentPage * limit;
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setup();
    },
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const { from, to } = this.$route.query;
      this.query = {
        from: this.$route.query.from || null,
        to: this.$route.query.to || null,
        project_id: this.$route.query.project_id || null,
        project: this.$route.query.project || null,
        home_no: this.$route.query.home_no || null,
        name: this.$route.query.name || null,
        page: this.$route.query.page || 1,
      };
      this.dateRange = [DateTime.fromISO(from), DateTime.fromISO(to)];
    },
    setupData() {
      this.setupFeedbackList();
    },
    async setupFeedbackList() {
      const { count, feedbacks } = await this.fetchData();
      const feedbackList =
        feedbacks &&
        feedbacks.length > 0 &&
        feedbacks.map((feedback) => {

          return {
            ...feedback,
            created_at: convertDateTimeToTimeText(feedback.created_at)
          };
        });

      this.feedbackList = feedbackList;
      this.total = count;
    },
    async fetchData() {
      const params = {
        project_id:
          this.query.project_id
            ? this.query.project_id
            : undefined,
        home_no: this.query.home_no || undefined,
        name: this.query.name || undefined,
        page: this.query.page || undefined,
        from: this.query.from || undefined,
        to: this.query.to || undefined,
      };

      try {
        const response = await baanRueJaiClient.admin.feedbacks.get(params);

        return response.data.result;
      } catch (error) {
        throw error;
      }
    },
    handleClickClear() {
      this.dateRange = "";
      this.query = {
        project: null,
        home_no: null,
        name: null,
      };
    },
    handleClickSearch() {
      let fromIso;
      let toIso;


      if (this.dateRange.length > 0) {
        const [from, to] = this.dateRange;
        fromIso = from.toISO();
        toIso = to.toISO();
      }

      const query = {
        from: fromIso,
        to: toIso,
        project: this.query.project,
        project_id: (this.query.project)
          ? this.query.project.projectId
          : null,
        home_no: this.query.home_no,
        name: this.query.name,
        page: 1,
      };
      this.$router.push({ query });
    },
    handleCurrentChange(page) {
      const query = {
        ...this.$route.query,
        page,
      };

      this.$router.push({ query });
    },
    handleChange(defaultProject) {
      this.query.project = defaultProject;
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();

      const requestParams = {
        project_id:
          this.query.project_id
            ? this.query.project_id
            : undefined,
        home_no: this.query.home_no || undefined,
        name: this.query.name || undefined,
        page: this.query.page || undefined,
        from: this.query.from || undefined,
        to: this.query.to || undefined,
        format: "xlsx",
      };
      const params = {
        params: requestParams,
        headers: {
          Accept: "application/octet-stream",
        },
        responseType: "blob"
      };
      const response = await await axios.get(`${process.env.HOST}${baanRueJaiClient.admin.feedbacks.baseURL}`, params);
      const now = DateTime.now().toFormat("yyyyMMddHHmm");
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `u-tell-us-reports-${now}.xls`;
      link.click();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: ($space / 2) $space;
}

.session-row {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 200px 60px 80px 100px 170px 340px 100px;
  width: max-content;

  border-bottom: $border;
  padding: 15px 10px;

  font-size: 16px;

  &:hover:not(.header) {
    text-decoration: none;
    background: #efefef;
    color: black;
  }

  &.header {
    color: #999;
    font-size: 14px;
  }

  >.status {
    text-align: center;
  }
}

.search {
  display: grid;
  grid-template-columns: 94% auto;
  border-bottom: $border;
}

.link {
  display: inline-block;
  opacity: 1;

  &.back-page {
    font-weight: normal;
    color: #999;
    font-size: 20px;
  }

  &.name {
    font-weight: bold;
    font-size: 22px;
  }
}
</style>


// WEBPACK FOOTER //
// src/features/feedbacks/pages/FeedbackReportPage.vue